import { fromJS } from 'immutable';
import { createReducer } from '../store/utils';
import { SUMMARY_REPORT } from './actionConstants';

const INITIAL_STATE = fromJS({
    loading: false,
    error: null,
    actionState: null,
    summaryId: null,
    summary: {}
});

const handlers = {
    [SUMMARY_REPORT.CLOSE_MESSAGE](state) {
        return state.withMutations(mutableState => {
            mutableState.setIn(['error'], null);
        });
    },
    [SUMMARY_REPORT.RELOAD](state) {
        return state.withMutations(mutableState => {
            mutableState.setIn(['actionState'], null);
        });
    },
    [SUMMARY_REPORT.EXECUTING](state) {
        return state.setIn(['loading'], true);
    },
    [SUMMARY_REPORT.ON_FAILED](state, { data }) {
        return state.withMutations(mutableState => {
            mutableState.setIn(['error'], data);
            mutableState.setIn(['loading'], false);
        });
    },
    [SUMMARY_REPORT.ON_SUMMARY_FETCHED](state, { data }) {
        return state.withMutations(mutableState => {
            mutableState.setIn(['error'], null);
            mutableState.setIn(['loading'], false);

            mutableState.setIn(['summary'], data.summary);
        });
    },
    [SUMMARY_REPORT.ON_CONFIRMED](state, { data }) {
        return state.withMutations(mutableState => {
            mutableState.setIn(['actionState'], data.state);
            mutableState.setIn(['loading'], false);
        });
    }
};

export default createReducer(INITIAL_STATE, handlers);
